export enum SaveCardControls {
  Card = 'bank_card_item',
}
